import { sanitizeResumePreviewHtml } from '@/features/portfoliosettings/lib/entry-description-sanitize';

const PUBLIC_RESUME_OVERRIDES_STYLE = `<style id="kw-public-resume-overrides">
html,body,.template-section,.resume-container,.t40-container,#template-section{
  -webkit-user-select:none!important;
  user-select:none!important;
}
@media print{
  html,body{
    overflow:visible!important;
    height:auto!important;
    background:#fff!important;
  }
  .template-section,.resume-container,.t40-container,#template-section{
    overflow:visible!important;
    height:auto!important;
    max-height:none!important;
  }
}
</style>`;

/** Inject public-view overrides (copy protection + print) into sanitized resume HTML. */
export function preparePublicResumeHtml(html: string): string {
  const sanitized = sanitizeResumePreviewHtml(html);
  if (!sanitized) {
    return '';
  }
  if (sanitized.includes('id="kw-public-resume-overrides"')) {
    return sanitized;
  }
  if (/<\/head>/i.test(sanitized)) {
    return sanitized.replace(/<\/head>/i, `${PUBLIC_RESUME_OVERRIDES_STYLE}</head>`);
  }
  if (/<head[^>]*>/i.test(sanitized)) {
    return sanitized.replace(/<head([^>]*)>/i, `<head$1>${PUBLIC_RESUME_OVERRIDES_STYLE}`);
  }
  return `${PUBLIC_RESUME_OVERRIDES_STYLE}${sanitized}`;
}
